import React from 'react'
import { motion } from "motion/react"
import { useRevealInitial } from "../../lib/motion"

const ProjectTitle = ({ title, imgsrc }) => {
  return (
    <section id={title} className="mx-auto max-w-3xl px-6 pb-4 pt-32 text-center">
      <motion.div
        initial={useRevealInitial({ opacity: 0, y: 16 })}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
      >
        {imgsrc && (
          <img
            src={imgsrc}
            alt={title}
            className="mx-auto mb-6 max-h-72 w-full rounded-lg border border-ink-800 object-cover"
          />
        )}
        {title && <h1 className="text-3xl font-semibold text-mist-100 sm:text-4xl">{title}</h1>}
      </motion.div>
    </section>
  )
}

export default ProjectTitle
